export enum KEYWORD_PERMISSIONS {
  KEYWORD_VIEW = 'SEO_KEYWORDVIEW',
  KEYWORD_WRITE = 'SEO_KEYWORDWRITE',
}
